import styled from 'styled-components';

export const Page = styled.div`
  margin: 10px 100px;
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: ${props => props.theme.sizes.XL};
  font-weight: ${props => props.theme.fontWeights.semiBold};
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  grid-gap: 20px;
`;

export const PlaylistCard = styled.div`
  border: 1px solid ${props => props.theme.colors.lightGrey};
  border-radius: 4px;
  padding: 16px;
  background: ${props => props.theme.colors.white};
`;

export const CardTitle = styled.h3`
  margin: 0 0 10px;
  font-size: ${props => props.theme.sizes.L};
`;

export const MutedText = styled.p`
  color: ${props => props.theme.colors.superDarkGrey};
  font-size: ${props => props.theme.sizes.M};
  margin: 0 0 8px;
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
`;

export const Form = styled.div`
  max-width: 980px;
`;

export const Section = styled.section`
  border-bottom: 1px solid ${props => props.theme.colors.lightGrey};
  padding: 20px 0;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 16px;
  font-size: ${props => props.theme.sizes.L};
`;

export const Field = styled.div`
  margin-bottom: 16px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: ${props => props.theme.fontWeights.semiBold};
`;

export const InlineControls = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
`;

export const SelectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
`;

export const SelectionList = styled.div`
  border: 1px solid ${props => props.theme.colors.lightGrey};
  border-radius: 4px;
  max-height: 220px;
  overflow: auto;
  padding: 10px;
`;

export const PlaylistItem = styled.div<{ invalid?: boolean }>`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
  border: 1px solid
    ${props =>
      props.invalid
        ? props.theme.colors.alertSoftOrange
        : props.theme.colors.lightGrey};
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 10px;
  background: ${props =>
    props.invalid
      ? props.theme.colors.alertPaleYellow
      : props.theme.colors.white};
`;

export const ItemActions = styled.div`
  display: flex;
  gap: 6px;
`;

export const Footer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 20px;
`;
